window.addEventListener("load", () => {
  const body = document.querySelector("body");
  const observer = new MutationObserver((mutationsList, observer) => {
    if (!body.classList.contains("box_active_disable_scrolling")) {
      setTimeout(() => {
        if (!body.classList.contains("box_active_disable_scrolling")) {
          body.classList.add("add-videowise");
          observer.disconnect();
        }
      }, 15000);
    } else {
      observer.disconnect();
    }
  });

  observer.observe(body, { attributes: true, attributeFilter: ["class"] });

  if (!body.classList.contains("box_active_disable_scrolling")) {
    setTimeout(() => {
      if (!body.classList.contains("box_active_disable_scrolling")) {
        body.classList.add("add-videowise");
        observer.disconnect();
      }
    }, 15000);
  }
});
